import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import moment from "moment";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

export class ModalEnvoiBulletinOptions {
	public title?: string = "Envoi des bulletins"
	public message?: string = undefined;
	// eslint-disable-next-line @typescript-eslint/ban-types
	public callBackYes?: Function = undefined;
	// eslint-disable-next-line @typescript-eslint/ban-types
	public callBackNo?: Function = undefined;
	public canClose = true;
	public showDialog = false;
	public yesText?: string = "VALIDER";
	public noText?: string = "ANNULER";
	public closeAutoWhenValidated = true;

	public constructor(init?: Partial<ModalEnvoiBulletinOptions>) {
    	(<any>Object).assign(this, init);
	}
}

@Component
export default class modalEnvoiBulletin extends Vue {
	public canClose = false;
	public message?: string = undefined;
	public title?: string = "Envoi des bulletins"
	public isYesVisible = true;
	// eslint-disable-next-line @typescript-eslint/ban-types
	public callBackYes?: Function;
	public isNoVisible = true;
	// eslint-disable-next-line @typescript-eslint/ban-types
	public callBackNo?: Function;
	public yesText?: string = "VALIDER";
	public noText?: string = "ANNULER";
	public closeAutoWhenValidated = true;
	public isLoadingAnimationVisible = false;

	public init(options: ModalEnvoiBulletinOptions): void {
    	this.message = options.message;
    	this.canClose = options.canClose;
    	this.callBackYes = options.callBackYes;
    	this.isYesVisible = this.callBackYes != undefined;
    	this.callBackNo = options.callBackNo;
    	this.isNoVisible = this.callBackNo != undefined;
    	this.title = options.title;
    	this.yesText = options.yesText;
    	this.noText = options.noText;
    	this.closeAutoWhenValidated = options.closeAutoWhenValidated;
    	this.$forceUpdate();
    	if (options.showDialog) {
			$("#modalEnvoiBulletin").modal({ backdrop: "static" });
		} else {
			$("#modalEnvoiBulletin").modal("show");
		}
	}

	public valider(): void {
		this.isLoadingAnimationVisible = true;

		NotificationServiceInstance.SendSuccess("Envoi des bulletins de paie.");
		ServicesFactoryInstance.CalculPaieService.SendBulletinsDuMois(() => {
			this.isLoadingAnimationVisible = false;
			NotificationServiceInstance.SendSuccess("Envoi des bulletins de paie effectué avec succès.");
			this.closeModal();
		});
	}

	public displayLoadingAnimation(shouldDisplay: boolean): void {
    	this.isLoadingAnimationVisible = shouldDisplay;
	}

	public closeModal(): void {
    	this.displayLoadingAnimation(false);
    	$("#modalEnvoiBulletin").modal("hide");
	}

	public annuler(): void {
    	if (this.callBackNo != undefined) {
			this.callBackNo();
		}
    	this.closeModal();
	}
}




// WEBPACK FOOTER //
// ./src/components/modalComponents/modalEnvoiBulletin/modalEnvoiBulletin.ts